import { Stack } from "@mui/material";
import { Title } from "@src/appV2/redesign/system/ui-components";

import { BottomSheetHeader } from "../../../components/BottomSheetHeader";

interface SelectionHeaderProps {
  requiredShiftCount: number;
  totalShiftCount: number;
  onBack: () => void;
}

export function SelectionHeader(props: SelectionHeaderProps) {
  const { requiredShiftCount, totalShiftCount, onBack } = props;

  const isConfirmationMode = requiredShiftCount === totalShiftCount;
  const hasNoMinimum = requiredShiftCount <= 1;

  function getTitle(): string {
    if (hasNoMinimum) {
      return `Select from ${totalShiftCount} shifts`;
    }

    if (isConfirmationMode) {
      return "Confirm your bundle details";
    }

    return `Select at least ${requiredShiftCount} shifts`;
  }

  return (
    <Stack>
      <BottomSheetHeader onBack={onBack} />
      <Stack sx={{ paddingX: 6, paddingTop: 5, paddingBottom: 7, alignItems: "center" }}>
        <Title variant="h3" component="h2" sx={{ textAlign: "center" }}>
          {getTitle()}
        </Title>
      </Stack>
    </Stack>
  );
}
